import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ElementRef } from '@angular/core';
import { ContratoService, ProponenteService } from 'administrativo-lib';
import { Contrato, ContratoRemanejo, ContratoRemanejoItem, EddyAutoComplete, Favorecido, FuncaoService, GlobalService, Login, Prazo, Proponente, TipoContratacao, TipoContrato } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { ContratoItemService } from '../service/contrato-item.service';
import { ContratoRemanejoService } from '../service/contrato-remanejo.service';
import { PrazoService, TipoContratacaoService } from 'compra-lib';
import { takeUntil } from 'rxjs/operators';
import { error, success, warning } from 'toastr';

declare var $: any;

@Component({
  selector: 'app-contrato-remanejo-dlg',
  templateUrl: './contrato-remanejo-dlg.component.html',
})
export class ContratoRemanejoDlgComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  protected datepipe: DatePipe;
  public ptBR: any;
  protected unsubscribe: Subject<void> = new Subject();
  public manualEditValue = true;
  public confirmSave = false;
  public proponenteAtual: ContratoRemanejo;
  public apenasQtdeRemanejo: boolean = false;
  public proponente: Proponente;
  public mostrarBtnIncluirProp: boolean = false;
  public desabilitarBotaoSalvar = false;
  public listaTipos: { id: TipoContrato, nome: string }[];
  public listaContratacao: TipoContratacao[];
  public listaPrazos: Prazo[];
  public tipos: { id: 'CONTRATO' | 'REGISTRO_PRECO' | 'ATA_REGISTRO', nome: string }[];

  public proponenteAutoComplete: EddyAutoComplete<Proponente>;
  public proponenteAuto: Proponente;

  @Input() visualizar_item: boolean;
  @Input() entidade: ContratoRemanejo;
  @Input() listaRemanejo: ContratoRemanejo[] = []
  @Input() lista: Array<any>;
  @Input() login: Login;
  @Input() contrato: Contrato;
  @Output() visualizarChange: EventEmitter<boolean> = new EventEmitter();

  public imaskQtd = {
    mask: Number,
    scale: 4,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  public imaskQtdNeg = {
    mask: Number,
    scale: 4,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  imaskConfigValor = {
    mask: Number,
    scale: 4,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  imaskConfigValorNeg = {
    mask: Number,
    scale: 4,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  imaskConfig = {
    mask: Number,
    scale: 4,
    signed: false,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  constructor(
    public funcaoService: FuncaoService,
    public remanejoService: ContratoRemanejoService,
    private globalService: GlobalService,
    private contratoItemService: ContratoItemService,
    private contratoService: ContratoService,
    private confirmationService: ConfirmationService,
    protected contratacaoService: TipoContratacaoService,
    protected prazoService: PrazoService,
    private proponenteService: ProponenteService,
    private el: ElementRef
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['entidade'] && this.entidade?.id) {
      this.proponenteAtual = this.entidade;
    }
  }

  ngOnInit() {
    $('#dialogRemanejo').on('hidden.bs.modal', (e) => {
      this.proponenteAtual = null;
    });
    this.ptBR = this.globalService.obterDataBR();
    this.tipos = [{ id: 'CONTRATO', nome: 'Contrato' }, { id: 'REGISTRO_PRECO', nome: 'Registro de Preço' }];
    this.listaTipos = this.globalService.obterTiposContrato();
    this.contratacaoService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaContratacao = res ? res.content : [];
      }, e => error(e.message ? e.message : e));
    this.prazoService.filtrar(0, 0, { orgao_id: this.login.orgao.id }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.listaPrazos = res ? res.content : [];
      }, e => error(e.message ? e.message : e));
    this.proponenteAutoComplete = new EddyAutoComplete(null, this.proponenteService,
      'favorecido.id', ['favorecido.nome'], { 'licitacao.id': this.contrato.licitacao.id, relations: 'favorecido', orderBy: 'favorecido.nome' }, { number: ['favorecido.id', 'favorecido.cpf_cnpj'], text: ['favorecido.nome'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => this.globalService.calendarMascara(), 500);
  }

  public async salvar(): Promise<void> {
    try {
      console.log(this.listaRemanejo)
      let listaSalvar: ContratoRemanejo[] = [];
      this.desabilitarBotaoSalvar = true;
      for (const remanejo of this.listaRemanejo) {
        if (remanejo.itens.find(i => i.quantidade > 0)) {
          if (!remanejo.especie) {
            throw new Error(`Por favor, selecione a espécie do remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }
          if (!remanejo.data_remanejo) {
            throw new Error(`É necessário informar a data do remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }
          if (!remanejo.data_contabilizacao) {
            throw new Error(`Por favor, informe a data de contabilização do remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }
          if (!remanejo.motivo) {
            throw new Error(`Por favor, preencha o campo motivo para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
          }
          if (!this.funcaoService.podeAlterarAudesp(remanejo.data_contabilizacao, this.login)) {
            throw new Error(`Data de contabilização inválida para o remanejo de ${remanejo.proponente.favorecido.nome}. O período contábil já está fechado. Entre em contato com o contador.`);
          }

          const dtContabilizacao: Date = remanejo.data_contabilizacao;
          if (dtContabilizacao.getFullYear() !== this.login.exercicio.ano) {
            throw new Error(`O ano da data de contabilização do remanejo de ${remanejo.proponente.favorecido.nome} está diferente do exercício logado.`);
          }

          if (remanejo['incluirContrato']) {
            if (!remanejo['numero']) {
              throw new Error(`Por favor, informe o número do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['tipo']) {
              throw new Error(`Por favor, selecione o tipo de contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['data_assinatura']) {
              throw new Error(`É necessário informar a data de assinatura do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['data_inicio']) {
              throw new Error(`É necessário informar a data de início do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['data_termino']) {
              throw new Error(`É necessário informar a data de término do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['data_contabilizacao_contrato'] && !remanejo['inativo']) {
              throw new Error(`Para contratos ativos, é obrigatório informar a data de contabilização para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['tipo_contratacao']) {
              throw new Error(`Por favor, selecione o tipo de contratação para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
            if (!remanejo['prazo']) {
              throw new Error(`Por favor, selecione o prazo de pagamento do contrato para o remanejo: ${remanejo.proponente.favorecido.nome}.`);
            }
          }
          remanejo.itens = remanejo.itens.filter(i => i.quantidade > 0)
          remanejo.valor_total = this.totalizar(remanejo.itens)
          this.calcularTotalLSM(remanejo);
          listaSalvar.push(remanejo)
        }
      }
      if (listaSalvar.length) {
        await this.remanejoService.salvarLista(listaSalvar).toPromise();
        success('Remenajo inserido com sucesso!');
        $('#dialogRemanejo').modal('hide');
        this.confirmSave = false;
        // this.lista.concat(dados);
      } else {
        throw new Error(`Não houve nenhum remanejo realizado para salvar.`);
      }

      this.visualizarChange.emit(true);
    } catch (e) {
      this.desabilitarBotaoSalvar = false;
      this.funcaoService.acaoErro(e);
      return;
    }
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

  public onFocusDate() {
    this.globalService.calendarMascara();
  }

  public visualizarItem(visualizar_item) {
    if (visualizar_item === true) {
      return true
    } else {
      return false
    }
  }

  public toggleManualEdit(): void {
    this.manualEditValue = !this.manualEditValue;
  }

  public calcularTotalLSM(remanejo: ContratoRemanejo): void {
    const totalMaterial = remanejo.itens.reduce((acc, cur) => {
      if (!cur.contrato_item?.produto_unidade?.produto?.material?.servico) {
        return acc + (cur.valor_unitario * cur.quantidade);
      }
      return acc;
    }, 0);
    remanejo.valor_material = this.funcaoService.arredondar(totalMaterial, 2);

    const totalServico = remanejo.itens.reduce((acc, cur) => {
      if (
        cur.contrato_item?.produto_unidade?.produto?.material?.servico &&
        !cur.contrato_item?.produto_unidade?.produto?.material?.locacao
      ) {
        return acc + (cur.valor_unitario * cur.quantidade);
      }
      return acc;
    }, 0);
    remanejo.valor_servico = this.funcaoService.arredondar(totalServico, 2);

    const totalLocacao = remanejo.itens.reduce((acc, cur) => {
      if (cur.contrato_item?.produto_unidade?.produto?.material?.locacao) {
        return acc + (cur.valor_unitario * cur.quantidade);
      }
      return acc;
    }, 0);
    remanejo.valor_locacao = this.funcaoService.arredondar(totalLocacao, 2);
  }

  public async carregarRemanejos() {
    if (this.proponenteAtual && this.proponenteAtual?.proponente?.id) {
      let possuiContrato: any;
      if (this.contrato?.licitacao?.id) {
        possuiContrato = await this.contratoService.obter({
          'licitacao.id': this.contrato.licitacao.id,
          'favorecido.id': this.proponenteAtual.proponente.favorecido.id,
          'orgao.id': this.login.orgao.id,
          inativo: false, excluido: false,
        }).toPromise();
      }

      if (possuiContrato?.id || possuiContrato?.content?.length) {
        this.proponenteAtual['possuiContrato'] = true;
      }
      this.proponenteAtual['incluirContrato'] = !(possuiContrato?.id || possuiContrato?.content?.length);


      await this.carregarDadosContrato()
    }
    this.converterRemanejo()
  }

  public converterRemanejo() {
    this.proponenteAtual?.itens?.forEach((prop) => {
      const itemDaEntidade = this.proponenteAtual?.contrato?.itens.find(i => i.id === prop.contrato_item.id);
      if (itemDaEntidade) {
        let quantidadeAtual = itemDaEntidade['saldo_qtd'] !== undefined ? itemDaEntidade['saldo_qtd'] : itemDaEntidade.quantidade;
        this.listaRemanejo.forEach(remanejo => {
          if (this.proponenteAtual?.id && remanejo.id === this.proponenteAtual.id) {
            return;
          }
          const quantidadeRemanejada = remanejo?.itens?.reduce((acc, atual) => {
            if (atual.contrato_item.id === itemDaEntidade.id) {
              return acc + (+atual.quantidade);
            }
            return acc;
          }, 0);

          if (quantidadeRemanejada > 0) {
            quantidadeAtual -= quantidadeRemanejada;
          }
        });

        prop.saldo = prop.quantidade ? (quantidadeAtual + (+prop.quantidade)) : quantidadeAtual;
      }
    });
  }

  public totalizar(itens: ContratoRemanejoItem[]) {
    return this.funcaoService.arredondar(itens.reduce((acumulador, item) => (item.quantidade * item.valor_unitario) + acumulador, 0), 4)
  }

  public validarCamposRemanejo(item: ContratoRemanejoItem) {
    if (item.quantidade < 0) {
      error(`Por favor, informe a quantidade para o item: ${item?.contrato_item?.descricao}.`)
      this.carregarRemanejos()
    }
    if (item.quantidade > item.saldo && item.valor_unitario) {
      error(`A quantidade informada para o item ${item?.contrato_item?.descricao} é maior do que a prevista no item do contrato.`)
      item.quantidade = 0;
      this.carregarRemanejos()
    }
    const itemDoContrato = this.contrato.itens.find(i => i.id === item.contrato_item.id);

    if (itemDoContrato) {
      let quantidadeRemanejada = 0;
      this.listaRemanejo.forEach(remanejo => {
        const somaRemanejo = remanejo?.itens?.reduce((acc, atual) => {
          if (atual.contrato_item.id === itemDoContrato.id) {
            return acc + (+atual.quantidade);
          }
          return acc;
        }, 0);
        quantidadeRemanejada += somaRemanejo || 0;
      });
      const quantidadeTotal = quantidadeRemanejada // + (+item.quantidade);
      if (quantidadeTotal > itemDoContrato['saldo_qtd']) {
        error(`A quantidade informada para o item ${itemDoContrato.descricao} é maior do que a prevista no item do contrato.`);
        item.quantidade = 0;
        this.carregarRemanejos();
      }
    }
  }

  public adicionar() {
    // if (!this.mostrarBtnIncluirProp) return;
    this.mostrarBtnIncluirProp = true;
    this.proponente = new Proponente();
    this.proponente.favorecido = new Favorecido();
    this.proponente.situacao = 'HABILITADO';

    const modal = $(this.el.nativeElement).find('#dialogFavorecidoCadastro');
    if (modal.length > 0) {
      modal.modal('show');
    } else {
      $('#dialogFavorecidoCadastro').modal('show');
    }
  }

  public salvarProponente(item: Proponente) {
    if (!this.mostrarBtnIncluirProp) return;
    if (item) {
      if (+item.favorecido.tipo.tce !== 1 && +item.favorecido.tipo.tce !== 2 && +item.favorecido.tipo.tce !== 3) {
        warning('Verifique a espécie no cadastro de fornecedor');
        return;
      }
      if (item.favorecido?.id === this.contrato.favorecido?.id) {
        warning('Não é possível realizar remanejamento para o próprio contratado.');
        return;
      }

      this.atualizarOrdem();

      const itm = this.listaRemanejo.find((i) => i.proponente.favorecido.cpf_cnpj === item.favorecido.cpf_cnpj)
      if (itm) {
        itm.proponente.favorecido = item.favorecido;
        itm.proponente.epp_me = item.epp_me;
        itm.proponente.situacao = item.situacao;
        itm.proponente.motivo = item.motivo;
        this.proponenteAtual = itm;
      } else {
        if (this.listaRemanejo.length === 0) {
          item.ordem = 1;
        } else {
          item.ordem = (this.listaRemanejo.sort((a, b) => { return a.proponente.ordem - b.proponente.ordem })[this.listaRemanejo.length - 1].proponente.ordem) + 1;
        }
        let remanejoNovo = new ContratoRemanejo();
        remanejoNovo.data_remanejo = this.funcaoService.obterDataUTC(new Date());
        remanejoNovo.data_contabilizacao = this.funcaoService.obterDataUTC(new Date());
        remanejoNovo.contrato = this.contrato;
        remanejoNovo.usuario = this.login.usuario;
        remanejoNovo.exercicio = this.login.exercicio;
        remanejoNovo.proponente = item;
        remanejoNovo.especie = 'E'
        remanejoNovo.editavel = true;
        remanejoNovo.valor_total = 0;
        remanejoNovo.itens = [];
        for (const item of this.contrato.itens) {
          let saldoAtual = item['saldo_qtd'] !== undefined ? item['saldo_qtd'] : item.quantidade;
          remanejoNovo.itens.push({ quantidade: 0, saldo: saldoAtual, valor_unitario: item['vl_unit_atualizado'], contrato_item: item });
        }

        this.listaRemanejo.push(remanejoNovo)
        this.proponenteAtual = this.listaRemanejo[this.listaRemanejo.length - 1]
      }
      this.carregarRemanejos();
    }
    this.proponente = undefined
  }

  private atualizarOrdem() {
    if (!this.mostrarBtnIncluirProp) return;
    let ordem = 0;
    this.listaRemanejo.forEach((m) => {
      m.proponente.ordem = ++ordem;
    });
  }

  public async carregarDadosContrato() {
    if (this.proponenteAtual['incluirContrato']) {
      this.proponenteAtual['tipo'] = this.contrato.tipo;
      this.proponenteAtual['tipo_contratacao'] = this.contrato.tipo_contratacao;
      this.proponenteAtual['tipo_contrato'] = this.contrato.tipo_contrato;
      this.proponenteAtual['ano'] = new Date().getFullYear();
      this.proponenteAtual['modalidade'] = this.contrato.modalidade;
      this.proponenteAtual['inativo'] = this.login.parametro['licitacao']?.contratos_inativos;
      this.proponenteAtual['numero'] = await this.contratoService.proximoNumero(this.login.exercicio.ano, this.login.orgao.id).toPromise();
      this.proponenteAtual['objeto'] = this.contrato.objeto;
    }
  }

  selecionarProponente(proponenteSelecionado: Proponente) {
    this.proponenteAtual = {
      data_remanejo: this.funcaoService.obterDataUTC(new Date()),
      data_contabilizacao: this.funcaoService.obterDataUTC(new Date()),
      contrato: this.contrato,
      usuario: this.login.usuario,
      exercicio: this.login.exercicio,
      proponente: proponenteSelecionado,
      editavel: true,
      especie: 'E',
      valor_total: 0,
      itens: this.contrato.itens.map(item => ({
        quantidade: 0,
        saldo: item['saldo_qtd'] !== undefined ? item['saldo_qtd'] : item.quantidade,
        valor_unitario: item['vl_unit_atualizado'],
        contrato_item: item
      }))
    };

    this.listaRemanejo.push(this.proponenteAtual);

    this.carregarRemanejos();
  }
}
